import type { AcuityEffectiveScore, CurrentAcuityScoreResponse } from "@/core/types";
import { AcuityScoreBadge } from "@/features/acuity/components/AcuityScoreBadge";

import { getFormattedAcuityDate } from "../helpers/getFormattedAcuityDate";
import { PatientData } from "../../components/PatientData";

type EffectiveAcuityIndexProps = {
  effective_score: CurrentAcuityScoreResponse["effective_score"];
};

export function EffectiveAcuityIndex({ effective_score }: EffectiveAcuityIndexProps) {
  const { resolved_at, score } = effective_score || {};

  return (
    <>
      <PatientData
        className="tw:flex tw:items-baseline"
        classNameChildren="tw:flex"
        label="Acuity Index"
      >
        <AcuityScoreBadge acuityScore={score} />
      </PatientData>

      {score && resolved_at && <Label resolved_at={resolved_at} />}
    </>
  );
}

function Label({ resolved_at }: Pick<AcuityEffectiveScore, "resolved_at">) {
  const formattedDate = getFormattedAcuityDate(resolved_at);

  return (
    <PatientData className="tw:text-sm tw:text-text-tertiary tw:*:font-normal" label="Updated">
      {formattedDate}
    </PatientData>
  );
}
